const styles = {
    card: {
      maxWidth: { xs: 250, sm: 300, md: 345 },
      margin: "auto",
      
      backgroundColor: "rgba(0, 0, 0, 0.1)",
      
    },
    gridContainer: {
      spacing: 2,
      justifyContent: "center",
    },
  };
  
  export default styles;